import { render, staticRenderFns } from "./ReviewFileMapping.vue?vue&type=template&id=0374c741&scoped=true&"
import script from "./ReviewFileMapping.vue?vue&type=script&lang=js&"
export * from "./ReviewFileMapping.vue?vue&type=script&lang=js&"
import style0 from "./ReviewFileMapping.vue?vue&type=style&index=0&id=0374c741&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0374c741",
  null
  
)

export default component.exports